import React from "react"
import { useParams } from "react-router-dom"
import AdminRewardDetail from "../../Admin/Rewards/RewardDetail"

/**
 * Manage City — Reward detail + claimers.
 */
const AdminCityRewardDetail = () => {
  const { cityId } = useParams()

  return (
    <AdminRewardDetail
      listPath={`/admin/cities/${cityId}/rewards`}
      documentTitlePrefix="Reward"
    />
  )
}

export default AdminCityRewardDetail
